import useUserStore from 'hooks/useUserStore';

const REFERRAL_WHATSAPP_PHONE = '5657237245';

/** Encodes a value for the WhatsApp text query, keeping spaces as `+`. */
const formatToURL = (value: string): string => encodeURIComponent(value).replace(/%20/g, '+');

/**
 * Builds the WhatsApp deep link used by both "Recomendar Parrot" buttons.
 *
 * The message carries the current store name so the sales team knows who refers.
 * The store name comes from the legacy user-store hook, the same source the previous
 * referral screen used.
 *
 * @returns The ready-to-open WhatsApp URL
 */
export const useReferralWhatsappLink = (): string => {
  const { storeName } = useUserStore();
  const storeNameFormatted = formatToURL(storeName ?? '');

  return `https://api.whatsapp.com/send?phone=${REFERRAL_WHATSAPP_PHONE}&text=Soy+del+restaurante+${storeNameFormatted}+y+quiero+referir+a+alguien.+Llegué+del+canal+Portal+de+Reportes&type=phone_number&app_absent=0`;
};
